import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

const _FM_GirpadditionalfieldcollectionShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      return;
    }

    setLoading(true)
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/girp-additional-field-collection/" + id,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setLoading(false)
        setFormData(response?.data?.data || {});
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })
  }, [id])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
            {formData.name || t('girp_additional_field_collection_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/girp-additional-field-collection/update/' + id)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate('/girp-additional-field-collection')
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.created_at_snapshot ? moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss')) : '-'}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.updated_at_snapshot ? moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss')) : '-'}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="name">{t('name')}</label>
              <span className="p-d-block p-text-bold">
                {formData.name || '-'}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="description">{t('description')}</label>
              <span className="p-d-block p-text-bold">
                {formData.description || '-'}
              </span>
            </div>
          </div>
        </div>

        <DataTable
          size={"small"}
          value={(formData.items || []).slice().sort((a, b) => (a?.sort || 0) - (b?.sort || 0))}
          emptyMessage={t('empty_message')}
          responsiveLayout={window.App.state.responsiveLayout}
          breakpoint="1365px"
          stripedRows
          loading={loading}
        >
          <Column field="sort" header={t('sort')} style={{width: '90px'}}/>
          <Column field="name" header={t('id')}></Column>
          <Column field="label" header={t('label')}></Column>
          <Column header={t('related_to')} body={(rowData) => t((rowData?.related_to || '').toLowerCase())}></Column>
        </DataTable>
      </Panel>
    </>
  )
}

export default withTranslation('common')(_FM_GirpadditionalfieldcollectionShowComponent);
